import { lazy } from 'react';

const CharityVettingFoodHygieneRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "FoodHygiene" */ '../components/steps/food-hygiene-step/FoodHygiene'
    ),
);

export default CharityVettingFoodHygieneRoute;
